import React, { FC } from 'react';
import { SettingsCardsPageSkeleton } from 'src/components/pages/settings/settingsSkeleton';

export const ProofingHubPageSkeleton: FC = () => <SettingsCardsPageSkeleton />;
